
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { DeviceType, AppModule } from '@/store/modules/app';
import { AppMain, Navbar, Sidebar } from './components';
import ResizeMixin from './mixin/resize';
import { iBrand } from '@/interface/result';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
  },
})
export default class extends mixins(ResizeMixin) {
  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile,
    };
  }

  private brand: iBrand = {
    id: 'lingwoyun',
    name: '领沃云电脑海外版',
  };

  private getActiveBrand(): void {
    const brands: Array<iBrand> = UserModule.brands;
    if (brands) {
      const activeBrand = brands.find(x => x.id === UserModule.activeBrand);
      if (activeBrand) {
        this.brand = activeBrand;
      }
    }
  }

  private handleClickOutside() {
    AppModule.CloseSideBar(false);
  }

  created() {
    this.getActiveBrand();
  }
}
